window.onload = function() {
  setTimeout(function() {
    const container = document.querySelector('div[class*="wbcolllist-template-"]');
    
    if (container) {
      const button = container.querySelector("a.button.button--primary");
      const clistRight = container.querySelector("div.clist_right");
      
      if (button && clistRight) {
        clistRight.insertAdjacentElement("afterend", button);
      }
    }

    //const link = document.querySelector('header ul.list-menu li a[href="https://cursos.saborholistico.com/"]');
 
    //if (link) {
    //  link.setAttribute("target", "_blank");
    //}

    /*var menuLinks1 = document.querySelectorAll('a[href="https://referral.doterra.me/9558837"]');
    menuLinks1.forEach(function (link) {
        link.setAttribute('target', '_blank'); 
        link.setAttribute('rel', 'noopener noreferrer');
    });*/

    var menuLinks2 = document.querySelectorAll('a[href="/pages/recomendados"]');
    menuLinks2.forEach(function (link) {
        link.setAttribute('target', '_blank'); 
        link.setAttribute('rel', 'noopener noreferrer');
    });

    /*var menuLinks3 = document.querySelectorAll('a[href="https://www.healy.shop/?partnername=4321-6761-3328"]');
    menuLinks3.forEach(function (link) {
        link.setAttribute('target', '_blank'); 
        link.setAttribute('rel', 'noopener noreferrer');
    });*/

    var allLinks = document.querySelectorAll('a');

    // Recorrer cada enlace
    allLinks.forEach(function (link) {
        // Obtener el atributo href del enlace
        var href = link.getAttribute('href');
    
        // Verificar que el href no sea nulo y que no pertenezca al dominio "https://dominio.com"
        if (href && !href.startsWith('https://saborholistico.com/') && !href.startsWith('/') && !href.startsWith('#')) {
            link.setAttribute('target', '_blank'); 
            link.setAttribute('rel', 'noopener noreferrer');
        }
    });
    
    

    //mobileMenu = document.querySelector('#link-Shop ul.menu-drawer__menu.list-menu li:last-child');
  
  }, 500); // Espera de 1 segundo antes de ejecutar el código

};
